import { useState, useEffect, useCallback } from "react";
import "../../App.css";
import "./Home.css";
import axios from '../../api/apiClient';
import { token, domain } from "../Security";
import "react-tabs/style/react-tabs.css";

import {
  ShowIntroduction,
  ShowEmployeeInformation,
  ShowLatestTransactionRequests
} from "./components";
import { LoadingSpinner } from "../../common/Loading";

const Home = ({
  user, userAccess,
  employeePhoto, setEmployeePhoto,
  isHideSideMenu,
}) => {
  // Logic for "Your Profile" section (Shared between Intro and Legacy Requests)
  const [filteredEmployee, setFilteredEmployee] = useState([]);
  const [loadingProfile, setLoadingProfile] = useState(null);

  const apiUrl = domain + "/api/Employee";

  const fetchDataFilteredEmployee = useCallback(async () => {
    try {
      setLoadingProfile(true);
      const response = await axios.get(
        apiUrl + `/${user.employeePersonalInformationId}`,
        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
      );
      setFilteredEmployee(response.data);
    } catch (error) {
      console.error("Error fetching profile data:", error);
    } finally {
      setLoadingProfile(false);
    }
  }, [apiUrl, user]);

  useEffect(() => {
    if (!userAccess?.hasHome) {
      fetchDataFilteredEmployee();
    }
  }, [userAccess, fetchDataFilteredEmployee]);

  return (
    <div>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <ShowIntroduction
            filteredEmployee={filteredEmployee}
            setEmployeePhoto={setEmployeePhoto}
            user={user}
            userAccess={userAccess}
          />

          <div className="homeBody row">
            <div className="employee">
              {userAccess?.hasHome ? (
                /* 
                   Senior Refactor: ShowEmployeeInformation is now the entry point 
                   for the autonomous employee management section.
                */
                <ShowEmployeeInformation
                  user={user}
                  userAccessData={userAccess}
                  employeePhoto={employeePhoto}
                  setEmployeePhoto={setEmployeePhoto}
                />
              ) : (
                /* Legacy Component: Kept for backward compatibility */
                <ShowLatestTransactionRequests
                  user={user}
                  filteredEmployee={filteredEmployee}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <LoadingSpinner loading={loadingProfile} />
    </div>
  );
};

export default Home;